import { formatEventTimeRange } from '~/utils/format-event-times';

interface EventPurchaseContentProps {
  gymName: string | null;
  name: string;
  date: string | null;
  startTime: string | null;
  endTime: string | null;
  price: string | null;
  registrationCount?: number;
}

export function EventPurchaseContent({
  name,
  date,
  startTime,
  endTime,
  price,
  gymName,
  registrationCount = 1,
}: EventPurchaseContentProps) {
  return (
    <div className="mb-4">
      <p className="text-h6">{name}</p>
      {date ? <p className="text-subtitle2 uppercase">{date}</p> : null}
      {startTime && endTime ? (
        <p className="text-subtitle2 font-light uppercase">
          {formatEventTimeRange(startTime, endTime)}
        </p>
      ) : null}
      <p className="mt-4 text-caption font-light leading-none">
        {registrationCount > 1 ? `${registrationCount} event registrations` : 'Event Registration'}
      </p>
      {price != null ? <p className="font-medium">{price}</p> : null}
      {gymName ? <p className="text-caption font-light">{gymName}</p> : null}
    </div>
  );
}
